<template>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div >
        <transition
                enter-active-class="transition ease-out duration-100 transform"
                enter-class="opacity-0 -translate-y-full"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition ease-in duration-100 transform"
                leave-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 -translate-y-full"
        >
            <div    v-if="isOpen"
                    :class="bgColor"
                    class="rounded-md p-4">
                <slot name="banner-container">
                    <div class="flex items-start text-left">
                        <div class="shrink-0 flex items-center pt-0.5">
                            <slot name="icon">
                                <!-- Heroicon name: exclamation -->
                                <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                     fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                          clip-rule="evenodd"/>
                                </svg>
                            </slot>
                        </div>

                        <div class="ml-3">
                            <h3 :class="fgColor" class="text-sm text-left font-semibold my-0 py-0">
                                <slot name="title">(Default) Attention needed</slot>
                            </h3>
                            <div :class="fgColor + ' mt-1 text-sm'">
                                <slot name="content">
                                    <p>
                                        <b>Default</b> Banner Content
                                    </p>
                                </slot>
                            </div>
                        </div>
                    </div>
                </slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Banner",
    props: {
        bgColor: {
            type: String,
            default: 'bg-yellow-50',
        },
        fgColor: {
            type: String,
            default: 'text-yellow-700',
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        autoHide: {
            type: Number,
            default: 0,
        }
    },
    computed: {},
    created() {

    },
    data() {
        return {}
    },
    methods: {
    },
    watch: {
        isOpen(val, old) {
            if (this.autoHide !== 0) {
                setTimeout(() => {
                    this.$emit('update:isOpen', false)
                }, this.autoHide)
            }
        },
    }
}
</script>

<style scoped>

</style>